import { LOGIN_SUCCESS, DIRECT_LOGIN } from "../actionTypes";

const initialState = {
  admin_id: null,
  auth_token: null,
  company_id: null,
  full_name: null,
  hotel_name: null,
  directLogin: null,
  hotel_id: null,
};

const LoginReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        admin_id: action.payload.admin_id,
        auth_token: action.payload.auth_token,
        company_id: action.payload.company_id,
        full_name: action.payload.full_name,
        hotel_name: action.payload.hotel_name,
        hotel_id: action.payload.hotel_id,
      };
    case DIRECT_LOGIN:
      return {
        ...state,
        directLogin: action.payload,
      };
    default:
      return state;
  }
};

export default LoginReducer;
